import { render, staticRenderFns } from "./ContentBlockMarkdown.vue?vue&type=template&id=6105f51c&"
import script from "./ContentBlockMarkdown.vue?vue&type=script&lang=js&"
export * from "./ContentBlockMarkdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports